module.exports = __webpack_public_path__ + "static/media/nima-walk2.758ad4ae.png";